var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Edit")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4398862,16.2107069 L22.4398862,24.2678793 C22.4398862,25.4819483 21.4557828,26.4660517 20.2426448,26.4660517 L2.66285172,26.4660517 C1.44878276,26.4660517 0.46467931,25.4819483 0.46467931,24.2678793 L0.46467931,6.68808621 C0.46467931,5.47494828 1.44878276,4.49084483 2.66285172,4.49084483 L10.7200241,4.49084483",
    id: "Stroke-1",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.172414, 3.655148)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.2055345,
    y1: 0.0493448276,
    x2: 0.718293103,
    y2: 9.53658621,
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2055345,
    y1: 0.0493448276,
    x2: 0.718293103,
    y2: 9.53658621,
    id: "Stroke-5",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(13.034483, 5.336183)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.1191345,
    y1: 0.14397931,
    x2: 0.631893103,
    y2: 9.63122069,
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1191345,
    y1: 0.14397931,
    x2: 0.631893103,
    y2: 9.63122069,
    id: "Stroke-9",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.59167931,12.9856966 L6.78361034,18.7730069 C6.56481724,19.4703517 7.19885172,20.1351103 7.90643793,19.9516966 L13.928369,18.3884897 C14.4106448,18.263731 14.8510241,18.0114207 15.2029552,17.6604207 L25.9843345,6.87811034 C26.7114724,6.15097241 26.7114724,4.97228276 25.9843345,4.24514483 L22.7499207,1.01073103 C22.0227828,0.283593103 20.8431621,0.283593103 20.1160241,1.01073103 L9.2825069,11.8433172 C8.96316207,12.1626621 8.72761034,12.5546276 8.59167931,12.9856966 Z",
    id: "Stroke-11",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.37425862,
    y1: 16.8817034,
    x2: 9.92063793,
    y2: 19.4280828,
    id: "Stroke-13",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59167931,
    y1: 12.9856966,
    x2: 13.9618862,
    y2: 18.3559034,
    id: "Stroke-15",
    stroke: "#201574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.2e01cd69.svg";
export { ForwardRef as ReactComponent };